import { render, staticRenderFns } from "./periodical.vue?vue&type=template&id=5adcae00&scoped=true"
import script from "./periodical.vue?vue&type=script&lang=js"
export * from "./periodical.vue?vue&type=script&lang=js"
import style0 from "./periodical.vue?vue&type=style&index=0&id=5adcae00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adcae00",
  null
  
)

export default component.exports